package com.eladfinish.bible.contest.ui.animations

import androidx.compose.animation.core.LinearEasing
import androidx.compose.animation.core.RepeatMode
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.animation.core.repeatable
import androidx.compose.animation.core.tween
import androidx.compose.foundation.layout.offset
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.derivedStateOf
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.rotate
import androidx.compose.ui.unit.dp

@Composable
internal fun rememberShakeAnimation(
    animateWrongAnswer: Boolean,
    resetAnimateWrongAnswer: () -> Unit,
): Modifier {
    var rotationAnimationFinished by remember { mutableStateOf(false) }
    var translationAnimationFinished by remember { mutableStateOf(false) }
    var currentRotationAngle by remember { mutableStateOf(0f) } // Track current rotation
    var currentTranslationX by remember { mutableStateOf(0f) } // Track current translation

    val durationMillis = 40
    val rotationAngle by animateFloatAsState(
        targetValue = when {
            !animateWrongAnswer || rotationAnimationFinished -> 0f
            currentRotationAngle < 0f -> -2f
            else -> 2f
        },
        animationSpec = repeatable(
            iterations = if (animateWrongAnswer) 2 else 0,
            animation = tween(durationMillis = durationMillis, easing = LinearEasing),
            repeatMode = RepeatMode.Reverse,
        ),
        finishedListener = { rotationAnimationFinished = true },
    )
    val translationX by animateFloatAsState(
        targetValue = when {
            !animateWrongAnswer || translationAnimationFinished -> 0f
            currentTranslationX < 0f -> -10f
            else -> 10f
        },
        animationSpec = repeatable(
            iterations = if (animateWrongAnswer) 2 else 0,
            animation = tween(durationMillis = durationMillis, easing = LinearEasing),
            repeatMode = RepeatMode.Reverse,
        ),
        finishedListener = { translationAnimationFinished = true },
    )

    // Update current values whenever animation values change
    LaunchedEffect(rotationAngle) { currentRotationAngle = rotationAngle }
    LaunchedEffect(translationX) { currentTranslationX = translationX }

    val bothAnimationsFinished by derivedStateOf {
        rotationAnimationFinished && translationAnimationFinished
    }

    LaunchedEffect(bothAnimationsFinished) {
        if (bothAnimationsFinished) {
            rotationAnimationFinished = false
            translationAnimationFinished = false
            resetAnimateWrongAnswer()
        }
    }

    return Modifier
        .rotate(rotationAngle)
        .offset(x = translationX.dp)
}
